import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationModalContentContainer = (props: Props) => {
  const { children, size = 'md' } = props;

  const sizeStyles =
    size === 'lg' ? styles.contentContainerLG : styles.contentContainerMD;

  return <View style={[styles.contentContainer, sizeStyles]}>{children}</View>;
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  contentContainer: {
    gap: theme.spacing['4'],
  },
  contentContainerMD: {
    padding: theme.spacing['6'],
  },
  contentContainerLG: {
    paddingHorizontal: theme.spacing['6'],
    paddingVertical: theme.spacing['10'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  size?: 'md' | 'lg';
}>;
